import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=1bededbe&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bededbe')) {
      api.createRecord('1bededbe', component.options)
    } else {
      api.reload('1bededbe', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=1bededbe&", function () {
      api.rerender('1bededbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/atoms/Tabs/Tabs.vue"
export default component.exports